import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";

export const Footer = () => (
  <footer className="border-t border-[#27272a]/60 bg-[#0d0d10]" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 flex flex-col sm:flex-row items-start justify-between gap-10">
      <div>
        <div className="flex items-center gap-3">
          <LogoMark size={40} />
          <div className="leading-none">
            <span className="font-display font-black text-xl tracking-wide block">DUDU</span>
            <span className="font-mono-dt text-[10px] tracking-[0.35em] text-[#e03131] uppercase">Tattoo</span>
          </div>
        </div>
        <p className="text-sm text-zinc-500 mt-5 max-w-xs leading-relaxed">
          Estúdio autoral de tatuagem. Arte na pele, identidade eterna.
        </p>
      </div>
      <div className="flex gap-16">
        <div>
          <p className="font-mono-dt text-[10px] uppercase tracking-[0.3em] text-zinc-600 mb-4">Navegar</p>
          <div className="flex flex-col gap-2.5">
            {[["#galeria", "Galeria"], ["#sobre", "Sobre"], ["#servicos", "Serviços"], ["#agendamento", "Agendar"]].map(([href, label]) => (
              <a key={href} href={href} className="text-sm text-zinc-400 hover:text-[#e03131] transition-colors">{label}</a>
            ))}
          </div>
        </div>
        <div>
          <p className="font-mono-dt text-[10px] uppercase tracking-[0.3em] text-zinc-600 mb-4">Estúdio</p>
          <div className="flex flex-col gap-2.5">
            <Link to="/admin" className="text-sm text-zinc-400 hover:text-[#e03131] transition-colors" data-testid="footer-admin-link">Área do Estúdio</Link>
            <a href="#contato" className="text-sm text-zinc-400 hover:text-[#e03131] transition-colors">Contato</a>
          </div>
        </div>
      </div>
    </div>
    <div className="border-t border-[#27272a]/60">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mono-dt text-[10px] uppercase tracking-[0.25em] text-zinc-600">© 2026 Dudu Tattoo Studio</p>
        <p className="font-mono-dt text-[10px] uppercase tracking-[0.25em] text-zinc-600">Dudu Tattoo — Brasil</p>
      </div>
    </div>
  </footer>
);
